import { Chip, ChipProps } from '@mui/material'
import { UserRoleType, GetUserRoleProps } from 'interface/user'

type UserRoleChipProps = {
  role: UserRoleType | string
} & ChipProps
export const UserRoleChip = ({
  role,
  ...others
}: UserRoleChipProps) => {
  return <Chip {...others} {...GetUserRoleProps(role)} variant="filled"/>
}
